import PerformanceDashboard from './PerformanceDashboard';

export default PerformanceDashboard;
